// @ts-nocheck
import { Controller } from 'react-hook-form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ELEMENT_IDS, STYLES } from '../consts';
import { STATES_ARRAY } from '../../../flows/liliCard/constants';
import { ReactComponent as ArrowDownIcon } from '../../../assets/svg/arrow-down-blue.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/svg/inline-error.svg';

interface IProps {
    item: any;
    control: any;
    errors: any;
    trigger: any;
    setError: any;
    shouldHideField?: boolean;
}
export const RenderSelectField = ({
  item, control, errors, setError, shouldHideField,
}:IProps) => {
  const { t } = useTranslation();
  return (
    <div className={`${shouldHideField ? 'hidden' : ''} basis-1/2 relative fadeIn`} id={ELEMENT_IDS.LABEL_CONTROLLER_WRAPPER}>
      <ArrowDownIcon className={STYLES.SELECT_ICON} />
      <Controller
        name={item.inputId}
        control={control}
        rules={{
          required: item.requiredMessage || '',
        }}
        render={({ field }) => (
          <select
            id={`elInput-${item.inputId}`}
            className={`w-full relative ${errors[item.inputId]?.message ? 'errorState' : ''}`}
            {...field}
            onChange={(e) => {
              setError(item.inputId, '');
              field.onChange(e.target.value);
            }}
          >
            <option value='' defaultValue>{t(item.defaultOption)}</option>
            {STATES_ARRAY.map(i => <option key={i.STATE} value={i.POSTAL}>{i.STATE}</option>)}
          </select>
        )}
      />
      {errors[item.inputId]?.message && (
      <div className='errorWrapper flex items-center gap-[4px]'>
        <ErrorIcon />
        <p className='fadeIn' id={`${ELEMENT_IDS.INPUT_ERROR}-${item.inputId}`}>{t(errors[item.inputId]?.message)}</p>
      </div>
      )}

    </div>
  );
};
